module.exports = __webpack_public_path__ + "img/logo.df076d51.svg";